export default __webpack_public_path__ + "static/media/typescriptLogo.16240f48.png";